<script>
/**
 * Renderless component to provide self-contained toggle/switch state
 */
export default {
  props: {
    default: { type: Boolean, default: false },
  },
  data() {
    return {
      isOn: this.default,
    }
  },
  methods: {
    turnOn() {
      // This if is to avoid unnecessary events
      if (!this.isOn) {
        this.$emit('changed', true)
      }
      this.isOn = true
    },
    turnOff() {
      // This if is to avoid unnecessary events
      if (this.isOn) {
        this.$emit('changed', false)
      }
      this.isOn = false
    },
    toggle() {
      this.isOn = !this.isOn
      this.$emit('changed', this.isOn)
    },
  },
  render() {
    /**
     * @slot Provides slot scope<br>
     *   turnOn()<br>
     *   turnOff()<br>
     *   toggle()<br>
     *   isOn: bool
     */
    return this.$slots.default
      ? this.$slots.default({
          turnOn: this.turnOn,
          turnOff: this.turnOff,
          toggle: this.toggle,
          isOn: this.isOn,
        })
      : null
  },
}
</script>
